import React from "react";
import { QueryObserverResult } from "react-query";
import {
  DataTypes,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card } from "../card";
import { getTemplateKey } from "../../functions/workflowFunctions";
import FolderIcon from "../folderIcon";

interface CardMatterProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[], productId?: string } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
  region: string;
}

export const CardMatter: React.FC<CardMatterProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
  region,
}) => {
  return (
    <Card
      region={region}
      image={<FolderIcon />}
      importType="matter"
      templateKey={getTemplateKey("matter", region)}
      fileName="matter.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find((i) => i.importType === "matter")}
      headerText={DataTypes.Matters}
      description="Import Matters that have not already been entered into Smokeball. Matter types are then extracted for configuration."
      cardState={cardsState["matter"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}      
      productId={data?.productId}
    />
  );
};
